export function Wordmark({ tone = 'default' }: { tone?: 'default' | 'inverse' }) {
  const dot = tone === 'inverse' ? 'bg-white' : 'bg-primary';
  const text = tone === 'inverse' ? 'text-white' : 'text-ink';
  return (
    <span className={`inline-flex items-baseline gap-1.5 font-semibold tracking-tight ${text}`}>
      <span className={`inline-block h-2 w-2 translate-y-[-2px] rounded-full ${dot}`} aria-hidden />
      <span className="text-base">LYN Rx</span>
    </span>
  );
}
